<template>
    <div
        id="modal-freemium-extension-confirm"
        aria-hidden="true"
        aria-labelledby="modalFillInLabel"
        class="modal modal-default modal-delete"
        role="dialog"
        tabindex="-1"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <header class="modal-header">
                    <button aria-hidden="true" class="close" data-dismiss="modal" type="button">
                        <!-- TODO extract svg -->
                        <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.375 0.625C16.875 0.0625 16.0625 0.0625 15.5 0.625L9 7.125L2.5 0.625C1.9375 0.0625 1.125 0.0625 0.625 0.625C0.0625 1.125 0.0625 1.9375 0.625 2.5L7.125 9L0.625 15.5C0.0625 16.0625 0.0625 16.875 0.625 17.375C1.125 17.9375 1.9375 17.9375 2.5 17.375L9 10.875L15.5 17.375C16.0625 17.9375 16.875 17.9375 17.375 17.375C17.9375 16.875 17.9375 16.0625 17.375 15.5L10.875 9L17.375 2.5C17.9375 2 17.9375 1.125 17.375 0.625Z" fill="#676486" />
                        </svg>
                    </button>

                    <strong>{{ __('Patient extension') }}</strong>
                    <p v-html="__('Do you really want to extend this patient\'s Freemium/Transition time until :date?', {date: moment(freemiumExtension.date).format('D. M. YYYY')})"></p>
                </header>

                <div class="modal-body">
                    <div class="btn-group">
                        <VButton :label="__('Cancel')" modal-target="dismiss" variant="secondary" />
                        <VButton :label="__('Yes, extend')" modal-target="dismiss" type="submit" color="danger" @onClick="extend" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        freemiumExtension: {
            required: true
        }
    },
    data() {
        return {
            formData: {}
        }
    },
    mounted() {
        $('#modal-freemium-extension-confirm').modal('show')
    },
    methods: {
        async extend() {
            var that = this

            this.form = {
                freemium_end: this.freemiumExtension.date
            }

            await axios
                .post(`/patients/${this.freemiumExtension.id}/extend-freemium`, {
                    ...this.form
                })
                .then(function (e) {
                    Vuemit.fire('Extend-freemium--update-subscription-end-date', {id: that.freemiumExtension.id, date: that.date})
                    that.$emit('success', true)

                    $('#modal-freemium-extension-confirm').modal('hide')
                })
                .catch(function (error) {
                    console.log(error)
                })
        }
    }
}
</script>
